import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import { REDUCERS } from 'common/store/reducerConstants'

import type { ActiveJitsiTelehealthSession, JitsiTelehealthSliceType } from './jitsiTelehealth.type'

const jitsiTelehealthInitialState: JitsiTelehealthSliceType = {
  activeSession: null,
}

export const jitsiTelehealthSlice = createSlice({
  name: REDUCERS.JITSI_TELEHEALTH,
  initialState: jitsiTelehealthInitialState,
  reducers: {
    openTelehealthSession(
      _state,
      action: PayloadAction<ActiveJitsiTelehealthSession>,
    ): JitsiTelehealthSliceType {
      return { activeSession: action.payload }
    },
    closeTelehealthSession(): JitsiTelehealthSliceType {
      return { activeSession: null }
    },
  },
})

export const { openTelehealthSession, closeTelehealthSession } = jitsiTelehealthSlice.actions
